import { Component, inject } from '@angular/core';
import { BrnDialogRef, injectBrnDialogContext } from '@spartan-ng/brain/dialog';
import {
  HlmAlertDialogAction,
  HlmAlertDialogCancel,
  HlmAlertDialogDescription,
  HlmAlertDialogFooter,
  HlmAlertDialogHeader,
  HlmAlertDialogTitle,
} from '@mb/ui/alert-dialog';

export interface AlertDialogContext {
  title: string;
  description: string;
  cancelLabel: string;
  actionLabel: string;
  actionVariant: 'default' | 'destructive' | 'success';
}

@Component({
  selector: 'app-alert-dialog-content',
  standalone: true,
  imports: [
    HlmAlertDialogHeader,
    HlmAlertDialogTitle,
    HlmAlertDialogDescription,
    HlmAlertDialogFooter,
    HlmAlertDialogCancel,
    HlmAlertDialogAction,
  ],
  host: {
    class:
      'bg-background data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95 relative z-50 mx-auto grid w-full max-w-[calc(100%-2rem)] gap-4 rounded-lg border p-6 shadow-lg data-[state=closed]:duration-200 data-[state=open]:duration-200 sm:mx-0 sm:max-w-lg',
  },
  template: `
    <hlm-alert-dialog-header>
      <h2 hlmAlertDialogTitle>{{ ctx.title }}</h2>
      <p hlmAlertDialogDescription>{{ ctx.description }}</p>
    </hlm-alert-dialog-header>
    <hlm-alert-dialog-footer>
      <button hlmAlertDialogCancel (click)="onCancel()">
        {{ ctx.cancelLabel }}
      </button>
      <button
        hlmAlertDialogAction
        [variant]="
          ctx.actionVariant === 'destructive' ? 'destructive' : 'default'
        "
        (click)="onAction()"
      >
        {{ ctx.actionLabel }}
      </button>
    </hlm-alert-dialog-footer>
  `,
})
export class AlertDialogContentComponent {
  private readonly _dialogRef = inject(BrnDialogRef<boolean>);
  protected readonly ctx = injectBrnDialogContext<AlertDialogContext>();

  protected onCancel(): void {
    this._dialogRef.close(false);
  }

  protected onAction(): void {
    this._dialogRef.close(true);
  }
}
